// extracted by mini-css-extract-plugin
export default {"heading":"jC-z","corrected":"kC-z","redirectVerbiageContainer":"lC-z","redirectVerbiageText":"mC-z"};